import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Fleet Dashboard</h3>
                <p className="text-sm text-gray-600">
                    Get a high-level overview of your fleet's performance and status.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Key Metrics</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li><strong>Fleet Status:</strong> View active vs. inactive vehicles.</li>
                    <li><strong>Quick Access:</strong> Jump to important sections using the summary boxes.</li>
                    <li><strong>Real-time Data:</strong> The dashboard summarizes current fleet expenditures and activities.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Data Refresh</h4>
                <p className="text-sm text-gray-600">
                    The dashboard automatically fetches the latest data when you navigate to it or change your account context.
                </p>
            </section>
        </div>
    );
};

export default Help;
